import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { Form, Input } from "antd";

import Modal from "@app/components/modal";

import versionAliasStore from "@app/state/store/report-document/version-alias";

const UpdateVersionModal = observer(() => {
    const {
        isLoading,
        showUpdateVersionAliasModal,
        onCloseUpdateVersionAliasModal,
        onSubmitUpdateVersionAliasForm,
        versionNames,
        aliasIdForUpdate,
        aliases,
    } = versionAliasStore;
    const [form] = Form.useForm();
    const refReason = React.useRef(null);

    useEffect(() => {
        const alias = aliases.find((a) => a._id === aliasIdForUpdate);
        const versionName = alias ? alias.versionName : "";

        form.setFieldsValue({ versionName });
    }, [showUpdateVersionAliasModal]);

    /**
     * Cancel the edit
     */
    const cancel = () => {
        onCloseUpdateVersionAliasModal();
        form.resetFields();
    };

    /**
     * Save the new name
     */
    const save = async ({ versionName }) => {
        await onSubmitUpdateVersionAliasForm({ versionName });
        form.resetFields();
    };

    return (
        <Modal
            title={"Update Version Name"}
            visible={showUpdateVersionAliasModal}
            okText="Update"
            onOk={form.submit.bind(form)}
            okButtonProps={{ disabled: isLoading }}
            onCancel={cancel}
            width={600}
        >
            <div className="reason-form">
                <Form layout="vertical" form={form} onFinish={save}>
                    <p>You can rename a version from version history.</p>
                    <Form.Item
                        label="Name"
                        name="versionName"
                        rules={[
                            {
                                required: true,
                                message: "Please enter the new version name",
                                whitespace: true,
                            },
                            () => ({
                                validator(_, value) {
                                    const forbiddenWords = [...versionNames, "latest"];
                                    if (!value || !forbiddenWords.includes(value)) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(
                                        new Error(
                                            "A version exists with this name. Please choose another.",
                                        ),
                                    );
                                },
                            }),
                        ]}
                    >
                        <Input ref={refReason} />
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    );
});

export default UpdateVersionModal;
